module.exports = __webpack_public_path__ + "img/lazada.66707681.png";